export function isUndefined<T>(arg?: T): boolean {
  return typeof arg === 'undefined';
}
